'use strict';

/**
 *
 * @name: singlePlaylist
 *
 */

import DirectiveTemplate from './nn-single-playlist.directive.html';
import './nn-single-playlist.directive.scss';

function NnSinglePlaylistDirective(
  $rootScope,
  Playlist,
  transObject,
  $state,
  $location,
  $compile,
  $window,
  apiLoveService,
  apiPostService,
  nnModalsService,
  $translate,
  angularticsService,
  $timeout
) {

  'ngInject';

  return {
    replace: true,
    restrict: 'EA', // attr, because also used as a module
    scope: {
      content: '&',
      loaded: '=',
      slug: '=',
      top: '='
    },
    template: DirectiveTemplate,
    transclude: true,
    controller: NnSinglePlaylistDirectiveController,
    link: function(scope, element) {

      function terminate() {
        scope.$destroy();
        element.find('*').remove();
        element.remove();
      }

      if (!scope.item.jsonData.sources ||
        !scope.item.jsonData.sources[0] ||
        (!scope.item.jsonData.sources[0].playlistId &&
          !scope.item.jsonData.sources[0].order) ||
        (!scope.item.jsonData.sources[0].playlistId &&
          !scope.item.jsonData.sources[0].order[0])) {

        return terminate();
      }

      var postsWatch = scope.$watch('cache.posts.length', function(newVal) {

        if (typeof newVal !== 'undefined') {

          scope.loaded = true;

          if (scope.settings.singlePlaylist && $location.search().autoplay) {

            scope.settings.change = true;
          }

          postsWatch();
          scope.changeHtml()
        }
      });
      scope.baiduTongji = () =>{
        console.log(scope,1111)
        window._hmt.push(['_trackEvent', '组件', 'click', `parentType=${scope.item.parentType},index=${scope.item.index},moduleId=${scope.item.id},parentSlug=${scope.item.parentSlug || ''}`]);
      }
      scope.changeHtml = () => {
        // console.log(scope,2222)
        // window._hmt.push(['_trackEvent', '组件', 'click', `parentType=${scope.item.parentType},index=${scope.item.index},moduleId=${scope.item.id},parentSlug=${scope.item.parentSlug || ''}`]);
        scope.settings.change = true;
        scope.$apply();
      }

      scope.$watch('settings.playlistLoves', function(val) {

        if (!isNaN(val)) {

          scope.cache['lovesCount_' + $rootScope.lang2] = val;
        }
      });

      var sendToAnalytics = function(newVal) {

        var analyticsData = {
          pageTitle: scope.cache.posts[newVal].translations[$rootScope.lang].title,
          pageID: 'NA',
          primaryCategory: 'playlist pages',
          subCategory1: 'playlist list',
          subCategory2: 'playlist page',
          pageType: 'content pages',
          attributes: {
            videoName: scope.cache.posts[newVal].translations[$rootScope.lang].title,
            videoID: scope.cache.posts[newVal].id
          }
        };

        angularticsService.pageTrack(analyticsData);
      };

      scope.$watch('settings.index', function(newVal) {

        if (scope.settings.singlePlaylist && scope.settings.index === 0) {

          if (scope.cache && scope.cache.posts && scope.cache.posts.length) {

            sendToAnalytics(newVal);
          } else {

            var helperWatcher = scope.$watch('cache.posts', function(cachePosts) {

              if (cachePosts && cachePosts.length) {

                helperWatcher();
                sendToAnalytics(newVal);
              }
            });
          }
        }

        if ((newVal || newVal === 0) && scope.cache && scope.cache.posts) {
          $rootScope.$broadcast('postChange', scope.cache.posts[newVal]);
        }
        if (scope.playlistPage < scope.settings.playlistTotalPages && newVal === scope.cache.posts.length - 1) {
          scope.loadMore();
        }
      });

      scope.playIndex = function(event, index) {

        scope.settings.change = true;
        var data = {
          dontGoNext: true
        };

        $rootScope.$broadcast('filmFinished', data);
        $rootScope.showPersistentVideo = false;
        scope.settings.index = index;


        $timeout(() => {
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          })
        })
      };
    }
  };
}

function NnSinglePlaylistDirectiveController(
  $scope,
  playlistAnalytics,
  $rootScope,
  transObject,
  apiPostService,
  $state,
  $location,
  $translate,
  Playlist,
  nnModalsService,
  apiLoveService) {

  'ngInject';

  var rootWatchers = {};

  $scope.item = $scope.content();
  $scope.playlistAnalytics = playlistAnalytics;
  $scope.settings = {
    change: false,
    index: 0,
    playlistListing: false,
    singlePlaylist: false,
    playlistLoves: undefined,
    playlistIsLoved: false,
    playlistId: null,
    playlistThumbnailUrl: null,
    playlistTotalItems: null,
    playlistTotalPages: null,
    playlistTitle: null,
    playlistAuthorId: null,
    playlistIsPrivate: null
  };

  $rootScope.singlePlaylistSettings = $scope.settings;
  $scope.item.title = $scope.item.title || 'Playlist';

  $scope.moreSharePlaylistOn = function() {
    $scope.moreSharePlaylist = true;
  };

  if ($scope.item && $scope.item.playlists.length > 0 && !isNaN($scope.item.playlists[0].lovesCount)) {

    $scope.settings.playlistLoves = $scope.item.playlists[0]['lovesCount_' + $rootScope.lang2];
    $scope.settings.playlistId = $scope.item.playlists[0].id;
    $scope.settings.playlistAuthorId = $scope.item.playlists[0].UserId;
    $scope.settings.playlistIsPrivate = $scope.item.playlists[0].isPrivate;
  }

  if ($scope.item && $scope.item.playlists.length > 0 && typeof $scope.item.playlists[0].isLoved !== 'undefined') {

    $scope.settings.playlistIsLoved = $scope.item.playlists[0].isLoved;
    $scope.settings.playlistId = $scope.item.playlists[0].id;
    $scope.settings.playlistAuthorId = $scope.item.playlists[0].UserId;
    $scope.settings.playlistIsPrivate = $scope.item.playlists[0].isPrivate;
  }

  if ($state.current.name === 'main.playlistSingle') {

    $scope.settings.singlePlaylist = true;
    $scope.settings.playlistListing = false;
  } else if ($state.current.name === 'main.playlistListing') {

    $scope.settings.playlistListing = true;
    $scope.settings.singlePlaylist = false;
  } else {

    $scope.settings.singlePlaylist = false;
    $scope.settings.playlistListing = false;
  }

  var params = {};
  var method = 'get';

  if ($scope.item.jsonData.sources[0].playlistId) {

    params.id = $scope.item.jsonData.sources[0].playlistId;
    $scope.cache = $scope.item.playlists[0];
  }
  if ($scope.item.jsonData.sources[0].order) {

    params.order = $scope.item.jsonData.sources[0].order;
    params.limit = 1;
  }
  if ($scope.item.jsonData.sources[0].slug) {

    params.slug = $scope.item.jsonData.sources[0].slug;
    params.UserId = $scope.item.jsonData.sources[0].userId;
    method = 'getSlug';
  }
  if ($scope.item.jsonData.sources[0].userId) {

    params.UserId = $scope.item.jsonData.sources[0].userId;
    params.page = 1;
  }

  if (!$scope.item.jsonData.sources[0].playlistId || $scope.settings.singlePlaylist === true) {

    params.hasVideos = true;
    Playlist[method](params).$promise
      .then(function(res) {

        if (!res.id && res.items && res.items.length) {

          $scope.cache = res.items[0];
        } else {

          $scope.cache = res;
        }

        if ($scope.settings.singlePlaylist && !$scope.cache.videosCount) {

          $location.path('/').replace();
        }
        transObject.translate($scope.cache);
        transObject.getDuration($scope.cache);
        transObject.trueSlug($scope.cache);
        transObject.trueSlug($scope.cache.user);

        if ($scope.settings.singlePlaylist) {

          $rootScope.seo = {
            pageTitle: $scope.cache.translations[$rootScope.lang].seoTitle + ' | NOWNESS',
            metaDescription: $scope.cache.translations[$rootScope.lang].seoDescription,
            image: $scope.cache.thumbnailUrl
          };

          if($rootScope.lang === 'zh-cn'){
            weChatStuff();
          }
        }

        if ($scope.settings.singlePlaylist &&
          $location.path() !== '/previews' &&
          $scope.cache.translations[$rootScope.lang].slug !== $scope.slug) {

          $location.path('/playlist/' + $scope.cache.id + '/' + $scope.cache.translations[$rootScope.lang].slug).search('autoplay', $location.search().autoplay).replace();
        }

        if ($scope.settings.singlePlaylist) {

          apiPostService
            .getPost(false, false, 1, 8, false, false, true, false, false, false, params.id)
            .then(function(res) {

              $scope.settings.playlistTotalPages = res.data.meta.totalPages;
              $scope.settings.playlistTotalItems = res.data.meta.totalItems;

              res.data.items.forEach(function(item) {

                transObject.translate(item);
                transObject.trueSlug(item);
                transObject.getDuration(item);
              });

              $scope.cache.posts = res.data.items;
            });

          $scope.playlistPage = 1;
          $scope.loadMore = function() {

            if (!$scope.disableIS && $scope.playlistPage < $scope.settings.playlistTotalPages) {

              $scope.disableIS = true;
              $scope.playlistPage++;

              apiPostService
                .getPost(false, false, $scope.playlistPage, 8, false, false, true, false, false, false, params.id)
                .then(function(res) {

                  res.data.items.forEach(function(item) {

                    transObject.translate(item);
                    transObject.trueSlug(item);
                    transObject.getDuration(item);
                    $scope.cache.posts.push(item);
                  });
                  $scope.disableIS = false;
                }, function() {

                  $scope.disableIS = false;
                });
            }
          };
        }

        if (!$scope.settings.playlistLoves) {

          $scope.settings.playlistLoves = $scope.cache['lovesCount_' + $rootScope.lang2];
        }

        $scope.settings.playlistIsLoved = $scope.cache.isLoved;
        $scope.settings.playlistId = $scope.cache.id;
        $scope.settings.playlistThumbnailUrl = $scope.cache.thumbnailUrl;
        $scope.settings.playlistTitle = $scope.cache.translations[$rootScope.lang].title;
        $scope.settings.playlistAuthorId = $scope.cache.UserId;
        $scope.settings.playlistIsPrivate = $scope.cache.isPrivate;

        if (!$scope.settings.signlePlaylist) {
          $scope.loaded = true;
        }

      }, function(err) {

        $rootScope.errorRedirect(err);
      });
  } else {

    if ($scope.cache && !$scope.cache.translations.hasOwnProperty('en-us')) {

      transObject.translate($scope.cache);
      transObject.getDuration($scope.cache);
      transObject.trueSlug($scope.cache);
      transObject.trueSlug($scope.cache.user);

      if (!$scope.settings.playlistLoves) {

        $scope.settings.playlistLoves = $scope.cache['lovesCount_' + $rootScope.lang2];
      }

      $scope.settings.playlistIsLoved = $scope.cache.isLoved;
      $scope.settings.playlistId = $scope.cache.id;
      $scope.settings.playlistThumbnailUrl = $scope.cache.thumbnailUrl;
      $scope.settings.playlistTitle = $scope.cache.translations[$rootScope.lang].title;
      $scope.settings.playlistAuthorId = $scope.cache.UserId;
      $scope.settings.playlistIsPrivate = $scope.cache.isPrivate;
      $scope.loaded = true;

      if ($scope.settings.singlePlaylist) {

        $rootScope.seo = {
          pageTitle: $scope.cache.translations[$rootScope.lang].seoTitle + ' | NOWNESS',
          metaDescription: $scope.cache.translations[$rootScope.lang].seoDescription,
          image: $scope.cache.thumbnailUrl
        };

        if($rootScope.lang === 'zh-cn'){
          weChatStuff();
        }
      }
    }
  }


  function weChatStuff() {

    var getTicket = 'https://cn.nowness.com/weixin/api/sign?appId=wxbeb8766166a66f06';

    var params = {
      desc: $rootScope.seo.metaDescription,
      link: $location.$$absUrl,
      imgUrl: $rootScope.seo.image
    };

    $.getJSON(getTicket, { url: $location.$$absUrl.split('#')[0] }, function(data) {

      wx.config({
        debug: false,
        appId: 'wxbeb8766166a66f06',
        nonceStr: data.sign.nonceStr,
        timestamp: data.sign.timestamp,
        signature: data.sign.signature,
        jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareWeibo']
      });

      /*
       * 注意：
       * 1. 所有的JS接口只能在公众号绑定的域名下调用，公众号开发者需要先登录微信公众平台进入“公众号设置”的“功能设置”里填写“JS接口安全域名”。
       * 2. 如果发现在 Android 不能分享自定义内容，请到官网下载最新的包覆盖安装，Android 自定义分享接口需升级至 6.0.2.58 版本及以上。
       * 3. 完整 JS-SDK 文档地址：https://mp.weixin.qq.com/wiki/7/aaa137b55fb2e0456bf8dd9148dd613f.html
       */
      wx.ready(function() {
        // 2. 分享接口
        // 2.1 监听“分享给朋友”，按钮点击、自定义分享内容及分享结果接口
        wx.onMenuShareAppMessage(params);
        wx.onMenuShareTimeline(params);
        // 2.4 监听“分享到微博”按钮点击、自定义分享内容及分享结果接口
        wx.onMenuShareWeibo(params);
      });
      // wx.error(function(res) {
        // alert(res.errMsg);
      // });
    });
  }

  $scope.playlistLove = function() {

    var err = {};

    if ($rootScope.profile && $rootScope.profile.id === $scope.settings.playlistAuthorId) {

      err = {
        data: {
          message: $translate.instant('YOU_CAN_NOT_LOVE_YOUR_OWN_PLAYLIST')
        }
      };
      $rootScope.errors.push(err);
      return;
    }

    if ($scope.settings.playlistIsPrivate) {

      err = {
        data: {
          message: $translate.instant('YOU_CAN_NOT_LOVE_A_PRIVATE_PLAYLIST')
        }
      };
      $rootScope.errors.push(err);
      return;
    }

    if ($scope.settings.playlistIsLoved === false && $rootScope.profile) {

      apiLoveService
        .lovePlaylist($scope.settings.playlistId)
        .then(function() {

          $scope.settings.playlistIsLoved = true;
          $scope.settings.playlistLoves++;
        }, function(err) {

          $rootScope.errors.push(err.data);
        });
    } else if ($scope.settings.playlistIsLoved === true && $rootScope.profile) {

      apiLoveService
        .unlovePlaylist($scope.settings.playlistId)
        .then(function() {

          $scope.settings.playlistIsLoved = false;
          $scope.settings.playlistLoves--;
        }, function(err) {

          $rootScope.errors.push(err.data);
        });
    } else if (!$rootScope.profile) {
      $rootScope.playlistToLove = {
        id: $scope.settings.playlistId,
        thumbnailUrl: $scope.settings.playlistThumbnailUrl,
        title: $scope.settings.playlistTitle,
      };

      $rootScope.playlistToBeLoved = true;

      rootWatchers.profile = $rootScope.$watch('profile', function(newVal) {

        if (newVal) {

          rootWatchers.profile();

          if ($rootScope.profile && $rootScope.profile.id === $scope.settings.playlistAuthorId) {

            var err = {
              data: {
                message: $translate.instant('YOU_CAN_NOT_YOUR_OWN_PLAYLIST')
              }
            };
            $rootScope.errors.push(err);
            return;
          }

          apiLoveService
            .lovePlaylist($scope.settings.playlistId)
            .then(function() {

              $scope.settings.playlistIsLoved = true;
              $scope.settings.playlistLoves++;
            }, function(err) {

              $rootScope.errors.push(err);
            });
        }
      });

      nnModalsService.showModal('login')
    }
  };

  $scope.$on('$destroy', function() {

    Object.keys(rootWatchers)
      .forEach(function(killWatcherKey) {

        rootWatchers[killWatcherKey]();
      });
  });
}
export default NnSinglePlaylistDirective;



// WEBPACK FOOTER //
// ./app/pages/playlist/nn-single-playlist/nn-single-playlist.directive.js